// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.

const zIndices = {
  base: 1,
  focus: 10,
  high: 100,
  top: 1000
} as const;

export default zIndices;
